import * as React from 'react';
import { RootStore, withInjectedRootStore } from 'providers';
import { LoggedinHeader } from './LoggedinHeader';
import { STEP_ACTIONS } from 'stores/App.store';
import { PaymentCycle_BIMap } from 'services/BiLogger/BiLoggerTypes';
import { LoggedIn } from '../LoggedIn/LoggedIn';
import { AnonymousHeader } from './AnonymousHeader';

export interface AppHeaderProps {
  currentStep: number;
  rootStore: RootStore;
}

export class AppHeaderComp extends React.Component<AppHeaderProps> {
  handleWizardStepChange = (toSpecificStep: number) => {
    const { currentStep } = this.props;
    const {
      changeStep,
      appContext,
      currentProduct,
      currentCycle,
    } = this.props.rootStore.appStore;
    const currentStepBeforeStateUpdate = currentStep;
    if (toSpecificStep === currentStep) {
      return;
    }

    changeStep(
      STEP_ACTIONS.SPECIFIC,
      (from, to) => {
        if (toSpecificStep < currentStepBeforeStateUpdate) {
          appContext.biLogger.logStepBackBiEvent({
            fromStep: `change_${to}_from_${from}_bar`,
            productId: currentProduct.id,
            productGuid: currentProduct.guid,
            cycle: PaymentCycle_BIMap[currentCycle],
          });
        }
      },
      toSpecificStep,
    );
  };

  render() {
    return (
      <>
        <LoggedIn>
          {(isLoggedIn) =>
            isLoggedIn ? (
              <LoggedinHeader changeStep={this.handleWizardStepChange} />
            ) : (
              <React.Suspense fallback={<div />}>
                <AnonymousHeader />
              </React.Suspense>
            )
          }
        </LoggedIn>
      </>
    );
  }
}

export const AppHeader = withInjectedRootStore(AppHeaderComp);
